module.exports = __webpack_public_path__ + "static/img/img1.e797b0af.png";